<div class="countable-dialog chatbot-dialog" [ngClass]="{'expanded-window': expandState() && expandState()?.state === 'FULL' ,
      'contracted-window': expandState() && expandState()?.state === 'DEFAULT' }" (click)="$event.stopPropagation()">
    <mat-drawer-container class="countable-drawer-new c-chatbot w-100"
        [ngClass]="{'content-overlay': openDocRepo() || openContextWindow()}">
        <mat-drawer #drawer opened appResizableDrawer [minWidth]="300" [maxWidth]="500" (resizeEvent)="onResizePanelEnd($event)" style="width:300px;">
            <div class="flexbox-column gap-0 overflow-hidden bg-blue">
                <ai-side-bar [chats]="chatsList()" [updateChat]="updateChat()" [hasEngagements]="hasNoEngagements()"
                             [activeChatId]="selectedChat()?.id" [selectedEng]="selectedEng()"
                             (triggerAction)="triggerSideBarActions($event)" (chatListCount)="chatListCount($event)">
                </ai-side-bar>
            </div>

        </mat-drawer>
        <mat-drawer-content class="flexbox-row gap-0 overflow-hidden flex-nowrap flex-1 w-100">

            <div class="toogle-button-block button-block-left bg-blue-dark">
                <button mat-button class="button-medium-icon toogle-button text-white"
                        (click)="drawer.toggle()"></button>
                <div class="toogle-content d-flex">
                    <h6 class="title text-white">Chat</h6>
                </div>
            </div>

            <div class="flexbox-column gap-0 overflow-hidden flex-column h-100 flex-1">

            <div class="flexbox-row gap-8 chat-main-header p-3 flex-wrap flex-lg-nowrap">
                <mat-form-field class="fixed-label label-none icon-field-before"
                                [ngClass]="{'disabled': !!dialogInfo()?.hasNoEngagements}" floatLabel="always"
                                style="width:300px;max-width:100%;">
                    <mat-label>Select Engagement</mat-label>
                    <input class="bg-white shadow-none" matInput placeholder="By Engagement ID or Client Name"
                           (blur)="setSearchText($event)"
                           [formControl]="searchText" [matMenuTriggerFor]="engListMenu" #listMenu="matMenuTrigger">
                    <span matPrefix>
                        <i class="fa-regular fa-magnifying-glass"></i>
                    </span>
                </mat-form-field>

                @if (selectedEng()?.sourceType === 'QUICKBOOK') {
                    <span class="br-8"
                          [ngClass]="{'border border-error p-1' : !selectedEng()?.isActiveConnection, 'connected': selectedEng()?.isActiveConnection}">
                    <img draggable="false" (drop)="false"
                         src="/assets/images/ui-uplift-icons/logos/quickbooks-brand-white.png"
                         alt="partner" style="width:95px;">
                </span>
                }
                @if (selectedEng()?.sourceType === 'XERO') {
                    <span class="br-8"
                          [ngClass]="{'border border-error p-1' : !selectedEng()?.isActiveConnection, 'connected': selectedEng()?.isActiveConnection}">
                    <img draggable="false" width="34" src="assets/images/xero/logo-small.svg" alt="partner">
                </span>
                }

                <button mat-button mat-flat-button color="primary"
                    [ngClass]="{'refresh-eng minimised-state': hasRefresh()}"
                    class="button-default-icon shadow-none hover-action" [disabled]="!hasRefresh()" (click)="refreshDialog()">
                    <i class="fa-regular fa-copy fs-16"></i>
                    <span class="dot-12 bg-success-new minimised-icon"></span>
                    <div class="custom-tooltip hover-action-item">
                        <p [ngTemplateOutlet]="refreshChatSession"></p>
                    </div>
                </button>

                <div class="button-group gap-16 ms-auto pe-3 mob-right-menu">
                    <button mat-button mat-flat-button color="primary"
                            class="button-default-icon shadow-none hover-action bg-cyan"
                            [disabled]="hasNoEngagements() || !(selectedEng()?.engId > 0) || dialogInfo()?.isAiRestricted || selectedEng()?.isRestricted"
                            (click)="newChat(true)">
                        <span class="flexbox-row gap-8">
                            <i class="fa-regular fa-message-plus fs-18"></i>
                            <span class="button-label d-none">New Chat</span>
                        </span>
                        <div class="custom-tooltip-left hover-action-item w-auto text-nowrap">
                            Start New Conversation
                        </div>
                    </button>
                    @if (!isWindowMode()) {
                    <button mat-button class="button-text open-new-window-img hover-action"
                            [disabled]="inputImgPath()?.isDisabled"
                        (click)="openAsWindow()">
                        <div class="custom-tooltip hover-action-item text-start">
                            <div [ngTemplateOutlet]="openWindow"></div>
                        </div>
                        <i class="fa-regular fa-arrow-up-right-from-square text-white"></i>
                    </button>
                    <button mat-button class="button-text" title="{{expandState()?.title}}"
                        (click)="resizeWindow(expandState()?.state)">
                        <i [class]="expandState()?.iconClass"></i>
                    </button>
                    <button mat-button class="button-text" title="Minimize" [disabled]="hasNoSelection()"
                        (click)="minimizeWindow()">
                        <i class="fa-regular fa-square-minus text-white"></i>
                    </button>
                    <button mat-button class="button-text" title="Close" (click)="closeDialog()">
                        <i class="fa-regular fa-xmark fs-18 text-white"></i>
                    </button>
                    } @else {
                    <button mat-button class="button-text open-new-window-img hover-action"
                            [disabled]="(inputImgPath()?.isDisabled)"
                            (click)="convertWindowToDialog()">
                        <div class="custom-tooltip-left hover-action-item text-start">
                            <div [ngTemplateOutlet]="convertWindow"></div>
                        </div>
                         <i class="fa-regular fa-arrow-up-right-from-square fa-rotate-180 text-white"></i>
                    </button>
                    }
                </div>

                <!-- <mat-slide-toggle color="warn" class="me-3 ms-auto"></mat-slide-toggle> -->

            </div>
            <div class="flexbox-column gap-16 chat-main-window p-3 flex-1" #mainChatWindowEle
                 (scroll)="debouncedScroll()">
                @for (chat of chatHistory()?.messages; track $index; let index = $index) {
                @if (chat?.messageType === 'USER' || chat?.messageType === 'SYSTEM_USER') {
                <app-ai-user-chat-preview [chatPreview]="chat">
                </app-ai-user-chat-preview>
                }

                    @if (chat?.messageType === 'SYSTEM_AI') {
                        <div class="bot-chat flexbox-column gap-0 px-3">
                            <div class="flexbox-row gap-8">
                                <div class="bot-avatar align-self-start" style="width:34px;min-width:34px;">
                                    <img draggable="false" src="/assets/images/ui-uplift-icons/luca/bot-new-logo.svg"
                                         alt="">
                                </div>
                                @if (!chat?.showSpinner) {
                                    <div class="flexbox-column gap-8 pt-2 ps-1">
                                        <app-ai-loading-state
                                                [loadingState]="{
                                                promptType: 'FR',
                                                loadingType: (((index+1) === chatHistory()?.messages?.length) ? 'STREAM' : 'NONE'),
                                                text: chat?.lucaMarkdownResponse
                                            }"
                                                (showActionItems)="updateStreamingInfo(index,$event)"
                                        >
                                        </app-ai-loading-state>
                                        @if (((index + 1) !== chatHistory()?.messages?.length) || (((index + 1) === chatHistory()?.messages?.length) && chat?.isStreamingCompleted)) {
                                            <div class="button-group gap-8">
                                                <button mat-button mat-stroked-button color="dark"
                                                        (click)="copyText(index)"
                                                        [cdkCopyToClipboard]="chat?.lucaMarkdownResponse"
                                                        [ngClass]="{'copied-success': (hasCopiedText() === index)}"
                                                        class="button-smaller"
                                                        title="{{hasCopiedText() === index ? 'Copied' : 'Copy'}}">
                                                    <div class="flexbox-row gap-8">
                                                        <i class="fa-regular fa-clone"></i>
                                                        <span class="button-label">{{
                                                                hasCopiedText() === index ? 'Copied' : 'Copy'
                                                            }}</span>
                                                    </div>
                                                </button>
                                                <button mat-button mat-stroked-button color="dark"
                                                        [matMenuTriggerFor]="downloadMenu"
                                                        class="button-smaller" title="Download">
                                                    <div class="flexbox-row gap-8">
                                                        <i class="fa-regular fa-arrow-down-to-line"></i>
                                                        <span class="button-label">Download</span>
                                                        <i class="fa-solid fa-angle-down fs-15"></i>
                                                    </div>
                                                </button>
                                                @if ((selectedEng()?.engId > 0 && !selectedEng()?.isRestricted)) {
                                                    <button mat-button mat-stroked-button color="dark"
                                                            [matMenuTriggerFor]="saveEngMenu"
                                                            class="button-smaller" title="Save To Engagement">
                                                            <div class="flexbox-row gap-8">
                                                                <i class="fa-regular fa-print"></i>
                                                                <span class="button-label">Save</span>
                                                                <i class="fa-solid fa-angle-down fs-15"></i>
                                                            </div>
                                                    </button>
                                                }
                                                @if (actionMessage()?.index === index) {
                                                    <div [ngTemplateOutlet]="showMessage"></div>
                                                }
                                                <mat-menu #downloadMenu="matMenu" yPosition="below">
                                                    <button mat-menu-item (click)="downloadResponse(index,'PDF',chat);
                                                        setActionState(index,false);">
                                                        <img draggable="false"
                                                             src="/assets/images/ui-uplift-icons/global/pdf-icon.svg"
                                                             alt="icon"
                                                             width="18"/>
                                                        PDF
                                                    </button>
                                                    <button mat-menu-item (click)="downloadResponse(index,'XLSX',chat);
                                                        setActionState(index,false);">
                                                        <img draggable="false"
                                                             src="/assets/images/ui-uplift-icons/global/excel.svg"
                                                             alt="icon"
                                                             width="18"/>
                                                        EXCEL
                                                    </button>
                                                    <button mat-menu-item (click)="downloadResponse(index,'DOCX',chat);
                                                        setActionState(index,false);">
                                                        <img draggable="false"
                                                             src="/assets/images/ui-uplift-icons/global/word.svg"
                                                             alt="icon"
                                                             width="18"/>
                                                        WORD
                                                    </button>
                                                </mat-menu>
                                                <mat-menu #saveEngMenu="matMenu" yPosition="below">
                                                    <button mat-menu-item (click)="downloadResponse(index,'PDF',chat,true);
                                                        setActionState(index,true)">
                                                        <img draggable="false"
                                                             src="/assets/images/ui-uplift-icons/global/pdf-icon.svg"
                                                             alt="icon"
                                                             width="18"/>
                                                        PDF
                                                    </button>
                                                    <button mat-menu-item (click)="downloadResponse(index,'XLSX',chat,true);
                                                        setActionState(index,true)">
                                                        <img draggable="false"
                                                             src="/assets/images/ui-uplift-icons/global/excel.svg"
                                                             alt="icon"
                                                             width="18"/>
                                                        EXCEL
                                                    </button>
                                                    <button mat-menu-item (click)="downloadResponse(index,'DOCX',chat,true);
                                                        setActionState(index,true)">
                                                        <img draggable="false"
                                                             src="/assets/images/ui-uplift-icons/global/word.svg"
                                                             alt="icon"
                                                             width="18"/>
                                                        WORD
                                                    </button>
                                                </mat-menu>
                                            </div>
                                        }
                                    </div>
                                } @else {
                                    <div class="flexbox-column">
                                        <app-ai-loading-state
                                                [loadingState]="{
                                                    promptType: selectedPrompt()?.promptType ?? 'FR',
                                                    loadingType: 'LOADING',
                                                    text: ''
                                                }"
                                        >
                                        </app-ai-loading-state>
                                    </div>
                                }
                            </div>
                        </div>
                    }

                    @if (chat?.messageType === 'ASSISTANT') {
                        <div class="bot-chat flexbox-column gap-0 px-3">
                            <div class="flexbox-row gap-8">
                                <div class="bot-avatar align-self-start" style="width:34px;min-width:34px;">
                                    <img draggable="false" src="/assets/images/ui-uplift-icons/luca/bot-new-logo.svg"
                                         alt="">
                                </div>
                                @if (chat?.showSpinner) {
                                    <div class="flexbox-column">
                                        <app-ai-loading-state
                                                [loadingState]="{
                                                    promptType: selectedPrompt()?.promptType ?? 'FR',
                                                    loadingType: 'LOADING',
                                                    text: ''
                                                }"
                                        >
                                        </app-ai-loading-state>
                                    </div>
                                } @else {
                                    <div class="flexbox-column gap-8 pt-2 ps-1">
                                        @if (chat?.lucaResponseType === 'HTML') {
                                            <div class="tiny-mc-container response-{{index}}"
                                                 [innerHTML]="chat?.lucaResponseHtml | safeHtml"></div>
                                        } @else {
                                            <markdown [katex]="true" [katexOptions]="katexInfo()" class="msg-body response-{{index}}" id="{{index}}"
                                                      [data]="chat?.lucaMarkdownResponse"></markdown>
                                        }
                                        @if (!chat?.isLucaStreaming) {
                                            <div class="button-group gap-8">
                                                <button mat-button mat-stroked-button color="dark"
                                                        (click)="copyText(index)"
                                                        [cdkCopyToClipboard]="chat?.lucaMarkdownResponse"
                                                        [ngClass]="{'copied-success': (hasCopiedText() === index)}"
                                                        class="button-smaller"
                                                        title="{{hasCopiedText() === index ? 'Copied' : 'Copy'}}">
                                                    <div class="flexbox-row gap-8">
                                                        <i class="fa-regular fa-clone"></i>
                                                        <span class="button-label">{{
                                                                hasCopiedText() === index ? 'Copied' : 'Copy'
                                                            }}</span>
                                                    </div>
                                                </button>
                                                <button mat-button mat-stroked-button color="dark"
                                                        [matMenuTriggerFor]="downloadMenu"
                                                        class="button-smaller" title="Download">
                                                    <div class="flexbox-row gap-8">
                                                        <i class="fa-regular fa-arrow-down-to-line"></i>
                                                        <span class="button-label">Download</span>
                                                        <i class="fa-solid fa-angle-down fs-15"></i>
                                                    </div>
                                                </button>
                                                @if ((selectedEng()?.engId > 0 && !selectedEng()?.isRestricted)) {
                                                    <button mat-button mat-stroked-button color="dark"
                                                            [matMenuTriggerFor]="saveEngMenu"
                                                            class="button-smaller" title="Save To Engagement">
                                                        <div class="flexbox-row gap-8">
                                                            <i class="fa-regular fa-print"></i>
                                                            <span class="button-label">Save</span>
                                                            <i class="fa-solid fa-angle-down fs-15"></i>
                                                        </div>
                                                    </button>
                                                }
                                                @if (actionMessage()?.index === index) {
                                                    <div [ngTemplateOutlet]="showMessage"></div>
                                                }

                                                <mat-menu #downloadMenu="matMenu" yPosition="below">
                                                    <button mat-menu-item (click)="downloadResponse(index,'PDF',chat);
                                                            setActionState(index,false);">
                                                        <img draggable="false"
                                                             src="/assets/images/ui-uplift-icons/global/pdf-icon.svg"
                                                             alt="icon"
                                                             width="18"/>
                                                        PDF
                                                    </button>
                                                    <button mat-menu-item (click)="downloadResponse(index,'XLSX',chat);
                                                            setActionState(index,false);">
                                                        <img draggable="false"
                                                             src="/assets/images/ui-uplift-icons/global/excel.svg"
                                                             alt="icon"
                                                             width="18"/>
                                                        EXCEL
                                                    </button>
                                                    <button mat-menu-item (click)="downloadResponse(index,'DOCX',chat);
                                                            setActionState(index,false);">
                                                        <img draggable="false"
                                                             src="/assets/images/ui-uplift-icons/global/word.svg"
                                                             alt="icon"
                                                             width="18"/>
                                                        WORD
                                                    </button>
                                                </mat-menu>
                                                <mat-menu #saveEngMenu="matMenu" yPosition="below">
                                                    <button mat-menu-item (click)="downloadResponse(index,'PDF',chat,true);
                                                            setActionState(index,true)">
                                                        <img draggable="false"
                                                             src="/assets/images/ui-uplift-icons/global/pdf-icon.svg"
                                                             alt="icon"
                                                             width="18"/>
                                                        PDF
                                                    </button>
                                                    <button mat-menu-item (click)="downloadResponse(index,'XLSX',chat,true);
                                                            setActionState(index,true)">
                                                        <img draggable="false"
                                                             src="/assets/images/ui-uplift-icons/global/excel.svg"
                                                             alt="icon"
                                                             width="18"/>
                                                        EXCEL
                                                    </button>
                                                    <button mat-menu-item (click)="downloadResponse(index,'DOCX',chat,true);
                                                            setActionState(index,true)">
                                                        <img draggable="false"
                                                             src="/assets/images/ui-uplift-icons/global/word.svg"
                                                             alt="icon"
                                                             width="18"/>
                                                        WORD
                                                    </button>
                                                </mat-menu>
                                            </div>
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                    }


                    @if (chat?.messageType === 'WORKFLOW') {
                        <div class="bot-chat px-3">
                            <div class="flexbox-column gap-0">
                                <div class="flexbox-row gap-8">
                                    <div class="bot-avatar align-self-start" style="width:34px;min-width:34px;">
                                        <img draggable="false"
                                             src="/assets/images/ui-uplift-icons/luca/bot-new-logo.svg" alt="">
                                    </div>
                                    <div class="flexbox-column gap-8 pt-2 ps-1 w-100 overflow-hidden">
                                        @if (chat?.showSpinner) {
                                            <h6 class="title text-primary flexbox-row gap-8">
                                                <img draggable="false"
                                                     src="/assets/images/ui-uplift-icons/luca/chat-spiner.gif" alt=""
                                                     style="width:40px;">
                                            </h6>
                                        }
                                        <div class="flexbox-column gap-0 bot-response-outer">
                                            <div class="flexbox-row flex-column bot-response-body align-items-end">
                                                @if (chat?.specialPromptMessage) {
                                                    <div class="ai-table-inputs-outer w-100 flex-1">
                                                        @switch (chat?.specialPromptMessage) {
                                                            @case ('VARIANCE_ANALYSIS_INPUTS') {
                                                                <ai-table-input [inputInfo]="chat?.specialPromptData"
                                                                                (updateSelection)="updateVr($event,chat)">
                                                                </ai-table-input>
                                                            }
                                                            @case ('GENERAL_LEDGER') {
                                                                <ai-table-input [inputInfo]="chat?.specialPromptData"
                                                                                [allowSelectionChange]="chatHistory()"
                                                                                (draftSelection)="draftInputs($event)"
                                                                                (updateSelection)="updateGlSelection($event,chat)">
                                                                </ai-table-input>
                                                            }
                                                            @case ('IS') {
                                                                <ai-table-input [inputInfo]="chat?.specialPromptData"
                                                                                [inputFiles]="promptInputFiles$ | async"
                                                                                (updateSelection)="updateAttachedFiles($event,chat)">
                                                                </ai-table-input>
                                                            }
                                                            @case ('HST') {
                                                                <ai-table-input [inputInfo]="chat?.specialPromptData"
                                                                                (updateSelection)="updateAttachedFiles($event,chat)">
                                                                </ai-table-input>
                                                            }
                                                            @case ('RECONCILIATION') {
                                                                <ai-table-input [inputInfo]="chat?.specialPromptData"
                                                                                (updateSelection)="updateAttachedFiles($event,chat)">
                                                                </ai-table-input>
                                                            }
                                                            @case ('LAS') {
                                                                <ai-table-input
                                                                        [inputInfo]="chat?.specialPromptData"
                                                                        (updateSelection)="updateAttachedFiles($event,chat)">
                                                                </ai-table-input>
                                                            }
                                                            @case ('CAAS_PREFERENCES') {
                                                                <ai-table-input [inputInfo]="chat?.specialPromptData"
                                                                                (draftSelection)="draftInputs($event)"
                                                                                (updateSelection)="updateAmortizationInputs($event,chat)">
                                                                </ai-table-input>
                                                            }
                                                            @case ('CAPITAL_ASSETS') {
                                                                <ai-table-input [inputInfo]="chat?.specialPromptData"
                                                                                (draftSelection)="draftInputs($event)"
                                                                                (updateSelection)="updateAmortizationInputs($event,chat)">
                                                                </ai-table-input>
                                                            }
                                                            @case ('CAAS_SCHEDULE') {
                                                                <ai-table-input [inputInfo]="chat?.specialPromptData"
                                                                                [allowSelectionChange]="chatHistory()"
                                                                                (updateSelection)="updateCAASValues($event,chat)">
                                                                </ai-table-input>
                                                            }
                                                        }
                                                    </div>
                                                    @if (chat?.specialPromptMessage === 'GENERAL_LEDGER' ||
                                                    chat?.specialPromptMessage === 'CAAS_SCHEDULE') {
                                                        <div class="button-group gap-8 justify-content-start w-100">
                                                            <!--                                                            <button mat-button mat-stroked-button color="dark"-->
                                                            <!--                                                                    (click)="copyText(index)"-->
                                                            <!--                                                                    [cdkCopyToClipboard]="chat?.lucaMarkdownResponse"-->
                                                            <!--                                                                    class="button-smaller"-->
                                                            <!--                                                                    title="{{hasCopiedText() === index ? 'Copied' : 'Copy'}}">-->
                                                            <!--                                                                <div class="flexbox-row gap-8">-->
                                                            <!--                                                                    <img draggable="false" src="{{hasCopiedText() === index ? '/assets/images/ui-uplift-icons/global/file-copy-dark-gray.svg' : '/assets/images/ui-uplift-icons/global/file-copy-dark-gray.svg'}}"-->
                                                            <!--                                                                         alt="Copy">-->
                                                            <!--                                                                    <span class="button-label">{{-->
                                                            <!--                                                                            hasCopiedText() === index ? 'Copied' :-->
                                                            <!--                                                                                    'Copy'-->
                                                            <!--                                                                        }}</span>-->
                                                            <!--                                                                </div>-->
                                                            <!--                                                            </button>-->
                                                            <button mat-button mat-stroked-button color="dark"
                                                                    [matMenuTriggerFor]="downloadMenu"
                                                                    class="button-smaller"
                                                                    title="Download">
                                                                <div class="flexbox-row gap-8">
                                                                    <i class="fa-regular fa-arrow-down-to-line"></i>
                                                                    <span class="button-label">Download</span>
                                                                    <i class="fa-solid fa-angle-down fs-15"></i>
                                                                </div>
                                                            </button>
                                                            @if (!selectedEng()?.isRestricted) {
                                                                <button mat-button mat-stroked-button color="dark"
                                                                        [matMenuTriggerFor]="saveEngMenu"
                                                                        class="button-smaller"
                                                                        title="Save To Engagement">
                                                                    <div class="flexbox-row gap-8">
                                                                        <i class="fa-regular fa-print"></i>
                                                                        <span class="button-label">Save</span>
                                                                        <i class="fa-solid fa-angle-down fs-15"></i>
                                                                    </div>
                                                                </button>
                                                            }
                                                            @if (chat?.specialPromptMessage === 'CAAS_SCHEDULE' && isInEngagement()) {
                                                                <button mat-button mat-stroked-button color="dark"
                                                                        (click)="postEntry(chat)"
                                                                        class="button-smaller" title="Post Entry">
                                                                    <div class="flexbox-row gap-8">
                                                                        <i class="fa-regular fa-arrow-up-right-from-square"></i>
                                                                        <span class="button-label">Post Entry</span>
                                                                    </div>
                                                                </button>
                                                            }
                                                            @if (actionMessage()?.index === index) {
                                                                <div [ngTemplateOutlet]="showMessage"></div>
                                                            }
                                                            <mat-menu #downloadMenu="matMenu" yPosition="below">
                                                                <button mat-menu-item (click)="downloadCustomFile('PDF',false,chat);
                                                                        setActionState(index,false)">
                                                                    <img draggable="false"
                                                                         src="/assets/images/ui-uplift-icons/global/pdf-icon.svg"
                                                                         alt="icon" width="18"/>
                                                                    PDF
                                                                </button>
                                                                <button mat-menu-item (click)="downloadCustomFile('XLSX',false,chat);
                                                                        setActionState(index,false)">
                                                                    <img draggable="false"
                                                                         src="/assets/images/ui-uplift-icons/global/excel.svg"
                                                                         alt="icon" width="18"/>
                                                                    EXCEL
                                                                </button>
                                                                <button mat-menu-item (click)="downloadCustomFile('DOCX',false,chat);
                                                                        setActionState(index,false)">
                                                                    <img draggable="false"
                                                                         src="/assets/images/ui-uplift-icons/global/word.svg"
                                                                         alt="icon"
                                                                         width="18"/>
                                                                    WORD
                                                                </button>
                                                            </mat-menu>
                                                            <mat-menu #saveEngMenu="matMenu" yPosition="below">
                                                                <button mat-menu-item (click)="downloadCustomFile('PDF',true,chat);
                                                                        setActionState(index,true)">
                                                                    <img draggable="false"
                                                                         src="/assets/images/ui-uplift-icons/global/pdf-icon.svg"
                                                                         alt="icon" width="18"/>
                                                                    PDF
                                                                </button>
                                                                <button mat-menu-item (click)="downloadCustomFile('XLSX',true,chat);
                                                                        setActionState(index,true)">
                                                                    <img draggable="false"
                                                                         src="/assets/images/ui-uplift-icons/global/excel.svg"
                                                                         alt="icon" width="18"/>
                                                                    EXCEL
                                                                </button>
                                                                <button mat-menu-item (click)="downloadCustomFile('DOCX',true,chat);
                                                                        setActionState(index,true)">
                                                                    <img draggable="false"
                                                                         src="/assets/images/ui-uplift-icons/global/word.svg"
                                                                         alt="icon"
                                                                         width="18"/>
                                                                    WORD
                                                                </button>
                                                            </mat-menu>
                                                        </div>
                                                    }
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                } @empty {
                    <div class="flexbox-column gap-16 prompt-window justify-content-end h-100 overflow-hidden">
                        <!-- <h2 class="title text-primary text-center">Let’s get started! Tell me how can I help?</h2> -->
                        <div class="no-data-found">
                            <img draggable="false" src="/assets/images/ui-uplift-icons/global/empty-component-icon.svg"
                                 alt="Icon">
                            @if (isFetchingChat()) {
                                <span>Please Wait While we fetch the conversation for you...</span>
                            } @else {
                                <h6>No Active Engagements</h6>
                                @if (hasNoEngagements()) {
                                    <span>Create your first engagement to get started with the Luca experience</span>
                                } @else {
                                    <span>Add Clients, create an engagement, and connect your integrations to start automating your
                            workflow</span>
                                }
                            }
                        </div>

                    </div>
                }
                <span #endOfPage></span>

                @if (showPrompts() && (attachedFiles()?.length === 0 || !attachedFiles())) {
                    <div class="chat-block-center mt-auto">
                        <div class="prompt-view bg-secondary-lighter" style="margin-bottom:-16px;">
                            <mat-accordion>
                                <mat-expansion-panel class="top-icon-header" [disabled]="hasNoSelection()">
                                    <mat-expansion-panel-header>
                                        <mat-panel-title>
                                        <span class="panel-title hover-action flex-row align-items-center gap-8">
                                            <h5 class="title">Suggested Prompts</h5>
                                            <span class="togglable-icon">
                                                <i class="toogle-icon fa-solid fa-angle-right fs-3"></i>
                                            </span>
                                            @if (hasNoSelection()) {
                                                <div class="custom-tooltip-top hover-action-item">
                                                <p [ngTemplateOutlet]="myPrompts"></p>
                                            </div>
                                            }
                                        </span>
                                    </mat-panel-title>
                                </mat-expansion-panel-header>
                                <div class="button-group pt-3 border-top">
                                    @for (prompt of suggestedPrompts(); track $index) {
                                    <button mat-button mat-flat-button color="light" class="button-default"
                                        (click)="setWorkflow(prompt)">
                                        <div class="flexbox-row gap-8">
                                                <i class="fa-regular fa-bolt text-primary-darker"></i>
                                            <span class="button-label">{{ prompt?.prompt }}</span>
                                        </div>
                                    </button>
                                    }
                                </div>
                            </mat-expansion-panel>
                        </mat-accordion>
                    </div>
                    </div>
                }
                @if (attachedFiles()?.length > 0) {
                    <div class="chat-block-center mt-auto">
                        <div class="prompt-view bg-secondary-lighter" style="margin-bottom:-16px;">
                            <ul class="upload-files-list list-style-none p-3">
                                @for (file of attachedFiles(); track $index) {
                                    <li class="card upload-file-card overflow-hidden" title="{{ file.fileName }}">
                                        <span class="left-file-icon dot-28 icon-bordered-primary"
                                              style="border-width:4px!important;min-width:28px!important;">
                                            <i class="fa-regular fa-file text-primary"></i>
                                        </span>
                                        <div class="flexbox-row gap-4 justify-content-between flex-1 overflow-hidden">
                                            <h6 class="title text-ellipse flex-1">{{ file.fileName }}</h6>
                                            <div class="flexbox-row gap-4">
                                                @if (!file?.isInValid) {
                                                    <span class="badge badge-circle dot-16 bg-primary p-0">
                                                        <i class="fa-solid fa-check fs-2"></i>
                                                    </span>
                                                } @else {
                                                    <span class="badge badge-circle dot-16 bg-warning p-0" >
                                                        <i class="fa-regular fa-triangle-exclamation fs-2"></i>
                                                    </span>
                                                }
                                                <button mat-button class="button-text" (click)="removeFile($index,file)">
                                                    <i class="fa-regular fa-trash-can fs-14"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </li>
                                }
                            </ul>
                            @if (hasInValidFiles()) {
                                <span class="text-error d-flex px-3 pb-3 fs-12">
                                    Upload limited to 15 files, total size max 25MB, only 'pdf', 'txt', 'docx', 'csv', 'xlsx' and 'xls' formats allowed.
                                </span>
                            }
                        </div>
                    </div>
                }

                @if (showGoToTop()) {
                    <button mat-button mat-stroked-button color="dark" title="Back to top" (click)="scrollToTop()"
                            class="button-medium-icon back-to-top">
                            <i class="fa-regular fa-arrow-up"></i>
                    </button>
                }


            </div>

            <div class="chat-input-field px-3 pb-3">
                <button mat-button mat-stroked-button color="primary" title="Upload Attachment"
                        class="button-default-icon file-upload-button"
                        [disabled]="hasNoSelection() || hasPromptWorkFlow() || isFetchingChat()
                        || dialogInfo()?.isAiRestricted || (selectedEng()?.engId > 0 && selectedEng()?.isRestricted)"
                        [matMenuTriggerFor]="uploadMenu">
                        <i class="fa-regular fa-paperclip-vertical fs-18"></i>
                </button>

                <div class="flexbox-row position-relative"
                     [ngClass]="{'disabled': !!(inputImgPath() && inputImgPath()?.isDisabled)}">
                    <mat-form-field class="fixed-label w-100" floatLabel="always">
                        <!-- <mat-label>User input</mat-label> -->
                        <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMaxRows="4"
                                  (input)="handleUserInput('USER_INPUT')"
                                  (keydown.enter)="$event.preventDefault(); askGpt()" type="text"
                                  (blur)="resetUserInput($event)"
                                  placeholder="I am looking for..." [formControl]="userInput">
                        </textarea>
                    </mat-form-field>

                    @if (inputImgPath()?.iconClass) {
                        <button mat-button mat-flat-button color="primary" class="button-default-icon send-button"
                                [disabled]="hasNoEngagements() || hasNoSelection() || inputImgPath()?.isDisabled || hasInValidFiles() ||
                                ((inputImgPath()?.type === 'SEND') && !(userInput?.value?.trim() || (attachedFiles()?.length > 0))) ||
                                (inputImgPath()?.type === 'VOICE_START' && isVoiceChatDisabled())"
                                (click)="handleUserInput(inputImgPath()?.type)">
                            <!-- <img draggable="false" [src]="inputImgPath()?.imgPath" alt=""> -->
                             <i [class]="inputImgPath()?.iconClass"></i>
                        </button>
                    }
                </div>
            </div>

            @if (openDocRepo()) {
                <app-ai-document-repo class="chatbot-repo"
                                      [docRepoInfo]="{'userDetails': userDetails(), 'selectedEngagement': selectedEng()}"
                                      (closeDocRepo)="closeRepo($event)"></app-ai-document-repo>
            }

            <div class="context-outer" [ngClass]="{'context-window-drawer': openContextWindow()}">
                    <div class="ai-context">
                        @if(openContextWindow()) {
                            <app-ai-context class="d-flex w-100 h-100" [contextInputs]="{
                                selectedEng: selectedEng(),
                                selectedChat: selectedChat(),
                                chatHistory: chatHistory(),
                                contextInfo: contextRes(),
                                isLoading: isContextLoading() }"
                                            [isFullWindow]="expandState()?.state === 'FULL'"
                                            (closeContext)="closeContextWindow($event)" >
                            </app-ai-context>
                        }
                    </div>
                @if (selectedEng()?.engId > 0 && !selectedEng()?.isRestricted ) {
                    <div class="context-btn-block">
                        <span class="context-right-arrow" *ngIf="chatHistory() && (chatHistory().messages[1] && chatHistory().messages[1].messageType === 'ASSISTANT' || chatHistory().messages[2] && chatHistory().messages[2].messageType === 'ASSISTANT') &&  (isShownFreeContextArrow() < 3)">
                            <img draggable="false" src="/assets/images/ui-uplift-icons/luca/context-right-arrow-gif-t.gif" alt="Luca Context"/>
                        </span>

                        <!-- @if (!openContextWindow()) { -->
                            <button mat-button class="text-link toggle-context-btn" (click)="toggleContext()">
                                <div class="toogle-content d-flex">
                                    <img class="for-open" draggable="false" src="/assets/images/ui-uplift-icons/luca/context-luca-new.png" alt="Luca Context"/>
                                    <img class="to-close" draggable="false" src="/assets/images/ui-uplift-icons/luca/close-context-btn.png" alt="Close"/>
                                </div>
                            </button>
                        <!-- } -->
                    </div>
                }
            </div>
            </div>







        </mat-drawer-content>



    </mat-drawer-container>

</div>


<mat-menu #engListMenu="matMenu" class="bot-engagement-list-table">
    <div #engListView></div>
    @defer (on viewport(engListView)) {
        <app-ai-engagements [engList]="originalEngList()" [searchText]="searchEngText()" [selectedEng]="selectedEng()"
                            (changeEngagement)="setEngagement($event)"></app-ai-engagements>
    }

</mat-menu>

<mat-menu #uploadMenu="matMenu" #beforeMenu="matMenu" yPosition="above" xPosition="after">
    <button mat-menu-item title="Select From Repository" class="add-row-btn" (click)="openDocRepo.set(true)">
        <i class="fa-regular fa-folder text-primary-darker fw-medium fs-20"></i>
        <span>Select From Repository</span>
    </button>
    <button mat-menu-item title="Upload from computer" (click)="fileInput.click();" class="add-row-btn">
        <i class="fa-regular fa-display fw-medium fs-20 text-primary-darker"></i>
        <input hidden type="file" multiple #fileInput accept="*" (change)="onChangeFile($event)">
        <span>Upload from Computer</span>
    </button>
</mat-menu>

<ng-template #sessionManagement>
    <div class="countable-dialog confirmation-dailog" (click)="$event.stopPropagation()">
        <div mat-dialog-title class="dialog-header d-flex flex-column align-items-center p-0">
            <span class="badge badge-error badge-circle icon-bordered-error text-center">
                <i class="fa-regular fa-circle-info"></i>
            </span>
            <h4 class="title text-center">Session Management</h4>
            <button color="error" class="close" [mat-dialog-close]="false">
                <i class="fa-regular fa-xmark"></i>
            </button>
        </div>
        <div mat-dialog-content class="content dialog-body-content text-center gap-8 mt-2 mb-32">
            <p>We Noticed you had a previous active session with LucaAI</p>
            <p>Would you like to 'Continue' with the recent active session or Start with 'New Session'</p>
        </div>

        <div mat-dialog-actions class="dialog-footer">
            <button mat-button mat-stroked-button class="button-default" color="dark" [mat-dialog-close]="true">New
                Session
            </button>
            <button mat-button mat-flat-button class="button-default" color="error" [mat-dialog-close]="false">Continue
            </button>
        </div>
    </div>
</ng-template>

<ng-template #refreshSession>
    <div class="countable-dialog confirmation-dailog" (click)="$event.stopPropagation()">
        <div mat-dialog-title class="dialog-header d-flex flex-column align-items-center p-0">
            <span class="badge badge-error badge-circle icon-bordered-error text-center">
                <i class="fa-regular fa-circle-info"></i>
            </span>
            <h4 class="title text-center">Refresh Chat Session</h4>
            <button color="error" class="close" [mat-dialog-close]="false">
                <i class="fa-regular fa-xmark"></i>
            </button>
        </div>
        <div mat-dialog-content class="content dialog-body-content text-center gap-8 mt-2 mb-32">
            <p>This will refresh the chat session to the latest engagement</p>
            <p class="error">Note: The Previous session will be saved in the chat history</p>
            <p>Are you sure you want to refresh chat session?</p>
        </div>

        <div mat-dialog-actions class="dialog-footer">
            <button mat-button mat-stroked-button class="button-default" color="dark" [mat-dialog-close]="false">Cancel
            </button>
            <button mat-button mat-flat-button class="button-default" color="error" [mat-dialog-close]="true">Confirm
            </button>
        </div>
    </div>
</ng-template>

<ng-template #refreshChatSession>
    <div class="flexbox-column gap-8">
        <span><strong>Refresh Chat Session</strong></span>
        <span>This will allow you to switch to the latest session or engagement</span>
    </div>
</ng-template>

<ng-template #myPrompts>
    <div class="flexbox-column gap-8">
        <span><strong>Suggested Prompts</strong></span>
        <span>Search by client name/ID or engagement ID to activate and view prompts</span>
    </div>
</ng-template>

<ng-template #openWindow>
    <div class="flexbox-column gap-8">
        <span><strong>Open In New Window</strong></span>
        <span>Open in a new window for a focused experience.</span>
    </div>
</ng-template>

<ng-template #convertWindow>
    <div class="flexbox-column gap-8">
        <span><strong>Go Back To Platform</strong></span>
        <span>Return the screen to the default state</span>
    </div>
</ng-template>

<ng-template #showMessage>
    @if (actionMessage()?.actionType === 'DOWNLOAD') {
        @if (actionMessage()?.actionProgress === 'PROGRESS') {
            <span class="text-gray-6 fw-medium text-italic fade-animation">Downloading in progress...</span>
        }
        @if (actionMessage()?.actionProgress === 'COMPLETED') {
            <span class="text-gray-6 fw-medium text-italic fade-animation">Download completed successfully</span>
        }
    }
    @if (actionMessage()?.actionType === 'SAVE') {
        @if (actionMessage()?.actionProgress === 'PROGRESS') {
            <span class="text-gray-6 fw-medium text-italic fade-animation">Saving to Engagement inside 'AI Generated Docs' is in
        progress...</span>
        }
        @if (actionMessage()?.actionProgress === 'FAILED') {
            <span class="text-gray-6 fw-medium text-italic fade-animation">Saving to Engagement failed.</span>
        }
        @if (actionMessage()?.actionProgress === 'COMPLETED') {
            <span class="text-gray-6 fw-medium text-italic fade-animation">Saved to Engagement inside 'AI Generated Docs' Successfully</span>
        }
    }
</ng-template>
